import { useQuery, useMutation } from "./urqlHooks";

const GET_MANY_COST_CENTER = `query GetManyCostCenter($companyId: String!) {
    getManyCostCenter(dto: { filter: { companyId: $companyId } }) {
        id
        name
        color
        colorLabel
        icon
        isHidden
        creationInformation {
            userId
            userEmail
            creationDate
        }
    }
}`;

export const GetCostCenter = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_MANY_COST_CENTER,
    variables: { companyId },
    pause: !companyId,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const UPDATE_COST_CENTER = `
  mutation UpdateCostCenter($id: String!, $input: CostCenterInput!) {
    updateCostCenter(
      dto: 
        { 
          id: $id, 
          input: $input 
        }
    ) {
      id
      companyId
      name
      color
      colorLabel
      icon
    }
  }
`;

export const UpdateCostCenter = () => {
  const [result, executeMutation] = useMutation(UPDATE_COST_CENTER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const MODIFY_COST_CENTER = `
  mutation ModifyCostCenter($companyId: String!, $input: [CostCenterToModifyInput!]!) {
    modifyCostCenter(dto: { companyId: $companyId, input: $input }) {
      ok
      nModified
    }
  }
`;

export const ModifyCostCenter = () => {
  const [result, executeMutation] = useMutation(MODIFY_COST_CENTER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const DELETE_COST_CENTER = `
  mutation DeleteCostCenter($id: String!, $companyId: String!) {
    deleteCostCenter(
      dto: { 
          id: $id,
          companyId: $companyId
         }
      ) {
         status
         message
    }
}
`;

export const DeleteCostCenter = () => {
  const [result, executeMutation] = useMutation(DELETE_COST_CENTER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const CREATE_COST_CENTER = `
  mutation CreateManyCostCenter($inputsArr: [CostCenterInput!]!) {
      createManyCostCenter(
        dto: {
          inputsArr: $inputsArr
        }
      ) {
          id
          companyId
          name
          color
          colorLabel
          icon
      }
  }
`;

export const CreateCostCenter = () => {
  const [result, executeMutation] = useMutation(CREATE_COST_CENTER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
